import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';

import Block from './block';

const Blocks = ({ blocks }) => {
  const blockNodes = [];
  blocks.forEach((block, idx) => {
    blockNodes.push(<Block block={block} key={`block-${idx + 1}`} />);
  });

  return (
    <div className="blocks">
      {blockNodes}
    </div>
  );
};

Blocks.propTypes = {
  blocks: PropTypes.instanceOf(List).isRequired,
};

export default Blocks;



// WEBPACK FOOTER //
// ./src/components/blocks/index.jsx